import Helper from '@/helpers/helpers'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routeFrom          : null,
    user               : null,
    globalStakeCalendar: [],
    isAdmin            : Helper.getCookie('stakeUserType') ?? 'subscriber'
  },
  mutations: {
    /* Update stake calendar */
    updateStakeCalendar(state, payload) {
      state.globalStakeCalendar = payload
    },
    /* Update active user */
    updateUser(state, payload) {
      state.user = payload
    },
    /* Update route from state */
    updateRouteFrom(state, payload) {
      state.routeFrom = payload
    }
  },
  actions: {
    /* Get user */
    getUser() {
      
    }
  },
})
